import React, {useEffect, useState} from 'react';

import './Select.country.scss';
import {getCountries} from "../../utils/address/addressFormat";
import {SelectLog} from "../../services/interactions/elements/select";

function SelectCountry({ value, onChange, onClick, placeholder, label, required, error, disabled, hasScroll, toTop }) {
    const inputRef = React.createRef();
    const [focused, setFocused] = useState(false);
    const [mouseOnOptions, setMouseOnOptions] = useState(false);
    const [preferredCountries, setPreferredCountries] = useState([]);
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        const preferred = ["us", "gb"];
        const countries = getCountries();
        const _referredCountries = [];
        let _countries = [];
        for (let k in countries) {
            if (countries.hasOwnProperty(k)) {
                const country = k.toLowerCase();
                if (preferred.includes(country)) {
                    _referredCountries.push({
                        label: countries[k].name,
                        value: country,
                        flag: country
                    });
                } else {
                    _countries.push({
                        label: countries[k].name,
                        value: country,
                        flag: country
                    });
                }
            }
        }
        _countries = _countries.sort((a, b) => {
            return a.label.localeCompare(b.label);
        });
        setPreferredCountries(_referredCountries);
        setCountries(_countries);
    }, []);

    const focusIn = () => {
        if (onClick) {
             onClick(true);
        }
        setFocused(true);
    }
    const overlayClick = () => {
        setTimeout(() => {
            setFocused(false);
            setMouseOnOptions(false);
        }, 120)
    }
    const focusOut = () => {
        if(!mouseOnOptions){
            // closeSubject.next(false);
            if (onClick) {
                 onClick(true);
            }
            setFocused(false);
        }
    }
    const toggleFocus = () => {
        if(!focused){
            inputRef.current.focus();
        }else{
            inputRef.current.blur();
        }
    }
    const overOptions = () => {
        setMouseOnOptions(true);
    }
    const outsideOptions = () => {
        setMouseOnOptions(false);
    }

    const selectOption = (option) => {
        return () => {
            if(!!option.disabled){
                return;
            }
            console.log('[SELECT] value: ', option.value);
            onChange(option.value);
            setFocused(false);
        }
    }

    const optionLabel = !!value || value === 0 ? preferredCountries.find(o => o.value === value) || countries.find(o => o.value === value) : '';
    return (
        <div className={`__SelectCountry ${label ? 'withLabel' : ''} ${focused ? 'focused' : ''} ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
            <label>{label}{required ? <span className="__req">*</span> : ''}</label>
            <select ref={inputRef} onFocus={focusIn} onBlur={focusOut} disabled={!!disabled}></select>
            <div className={`__value ${optionLabel && optionLabel.flag ? ' _col2' : ''}`} onClick={toggleFocus}>
                <div className={`${optionLabel && optionLabel.flag ? 'iti-flag ' + optionLabel.flag : ''}`} >
                </div>
                {
                    !optionLabel ?
                        <p className="placeholder">{placeholder}</p>
                        : <p>{optionLabel.label}</p>
                }
                <i className="material-icons">
                    keyboard_arrow_down
                </i>
            </div>
            <div className={`__options ${hasScroll ? 'scrollBar' : ''} ${toTop ? 'toTop' : ''}`} onMouseOver={overOptions} onMouseOut={outsideOptions}>
                {preferredCountries.map(o => (
                    <div className={`__option ${o.disabled ? '_disabled' : ''}`} key={o.value} onClick={selectOption(o)}>
                        <div className={`iti-flag ${o.flag ? o.flag : ''}`} >
                        </div>
                        <p>{o.label}</p>
                    </div>
                ))}
                {
                    preferredCountries.length !== 0? <div className="divider"></div> : ''
                }
                {countries.map(o => (
                    <div className={`__option ${o.disabled ? '_disabled' : ''}`} key={o.value} onClick={selectOption(o)}>
                        <div className={`iti-flag ${o.flag ? o.flag : ''}`} >
                        </div>
                        <p>{o.label}</p>
                    </div>
                ))}
            </div>
            {
                focused ?
                <div className="_overlay" onClick={overlayClick}></div>
                : ''
            }
        </div>
    )
}

export default SelectLog(SelectCountry);
